<div class="task-ratings-container">
   <div class="button-toggle">
      <button
         mat-icon-button
         color="primary"
         [ngClass]="{ active: activeView === 'list' }"
         (click)="setView('list')"
      >
         <mat-icon>view_list</mat-icon>
      </button>
      <button
         mat-icon-button
         color="primary"
         [ngClass]="{ active: activeView === 'dashboard' }"
         (click)="setView('dashboard')"
      >
         <mat-icon svgIcon="chart-arc"></mat-icon>
      </button>
   </div>
   <ng-container *ngIf="activeView === 'list'">
      <app-table [config]="tableConfig" [filterBar]="filterConfig"></app-table>
   </ng-container>
   <ng-container *ngIf="activeView === 'dashboard'">
      <app-competency-dashboard
         (editTaskRating)="editFromDashboard($event)"
      ></app-competency-dashboard>
   </ng-container>
</div>

